import Api from "../../api/Api";
import { toast } from "react-toastify";
import axios from "axios";
import {
  ADD_LOCATIONS_FAIL,
  ADD_LOCATIONS_SUCCESS,
  DELETE_LOCATIONS_SUCCESS,
  GET_LOCATIONS,
  GET_LOCATIONS_SUCCESS,
  UPDATE_LOCATIONS_SUCCESS,
} from "./actionTypes";

export const loadLocation = () => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.get("/locations/get");

  toast.promise(req, {
    pending: "Getting locations...",
    success: {
      render({ data }) {
        dispatch({
          payload: {apples: data.data.data, exports: data.data.exports},
          type: GET_LOCATIONS_SUCCESS,
        });
        return "Your Data Is Ready";
      },
    },
    error: {
      render({ data }) {
        return "An error occurred while getting locations";
      },
    },
  });
};

export const addLocation = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/locations/add", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: ADD_LOCATIONS_SUCCESS,
        });
        return "locations added successfully";
      },
    },
    error: {
      render({ data }) {
        // return data?.data.response.data?.message;

        return data?.response.data?.message;
      },
    },
  });
};

export const updateLocation = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/locations/update", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_LOCATIONS_SUCCESS,
        });
        return "locations updated successfully";
      },
    },
    error: {
      render({ data }) {
        console.log(data);
        return "An error occurred while updating your locations";
      },
    },
  });
};

export const deleteLocation = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/locations/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: DELETE_LOCATIONS_SUCCESS,
        });
        return "locations deleted successfully";
      },
    },
    error: {
      render({ data }) {
        console.log(data);
        return "An error occurred while deleting your locations";
      },
    },
  });
};

